export function decodeReferralCode(hexCode?: string) {
  // TODO
  return hexCode
}
